/**
 * Menu Localization Constants
 *
 * Usage in entity configs:
 * ```typescript
 * menuCategory: MENU_CATEGORY_KEY + MenuCategories + MENU_NAME_SUFFIX
 * menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories + MENU_NAME_SUFFIX
 * ```
 */

export const MENU_CATEGORY_KEY = 'LanguageService::Menu.';
export const MENU_SUBCATEGORY_KEY = 'LanguageService::Menu.';
export const MENU_NAME_SUFFIX = '.Name';

/**
 * Main menu categories (base names without .Name suffix)
 */
export const MenuCategories = {
  Queries: 'Queries',
  Quality: 'Quality',
  Certification: 'Certification',
  Inventory: 'Inventory',
  ResearchAndDevelopment: 'ResearchAndDevelopment',
  Environment: 'Environment',
  Planning: 'Planning',
  PlanningOperational: 'PlanningOperational',
  Road: 'Road',
  Controlling: 'Controlling',
  Harvest: 'Harvest',
  General: 'General',
  Silviculture: 'Silviculture',
  Transportation: 'Transportation',
  Nursery: 'Nursery',
  WoodSupply: 'WoodSupply',
} as const;

/**
 * Menu subcategories (base names without .Name suffix)
 */
export const MenuSubcategories = {
  Planning: 'Planning',
  TablesInventory: 'Tables.Inventory',
  TransactionsInventory: 'Transactions.Inventory',
  QueriesInventory: 'Queries.Inventory',
  TablesPlanning: 'Tables.Planning',
  TransactionsPlanning: 'Transactions.Planning',
  QueriesPlanning: 'Queries.Planning',
  Silviculture: 'Silviculture',
  Tillage: 'Tillage',
  Road: 'Road',
  Harvest: 'Harvest',
  Load: 'Load',
  Activities: 'Activities',
  Bonus: 'Bonus',
  Calendar: 'Calendar',
  Quality: 'Quality',
  Queries: 'Queries',
  Certification: 'Certification',
  Consumables: 'Consumables',
  Contracts: 'Contracts',
  Structural: 'Structural',
  Geography: 'Geography',
  Incident: 'Incident',
  Inventory: 'Inventory',
  Liquidations: 'Liquidations',
  Locations: 'Locations',
  Location: 'Location',
  MachinesAndVehicles: 'MachinesAndVehicles',
  GeneticMaterial: 'GeneticMaterial',
  Environment: 'Environment',
  Operation: 'Operation',
  OperationPlanning: 'Planning.Operation',
  OperationNursery: 'Nursery.Operation',
  Parameters: 'Parameters',
  Persons: 'Persons',
  Processes: 'Processes',
  FinalProduct: 'FinalProduct',
  SAP: 'SAP',
  WoodStock: 'WoodStock',
  PlantTransportation: 'PlantTransportation',
  General: 'General',
  WoodSupply: 'WoodSupply',
  GisInconsistencies: 'GisInconsistencies',
} as const;

// Backwards compatibility
/** @deprecated Use MENU_CATEGORY_KEY instead */
export const MENU_LOCALIZATION_KEY = MENU_CATEGORY_KEY;

/**
 * Type-safe category type
 */
export type MenuCategory = typeof MenuCategories[keyof typeof MenuCategories];

/**
 * Type-safe subcategory type
 */
export type MenuSubcategory = typeof MenuSubcategories[keyof typeof MenuSubcategories];